<template>
    <toolbar-option>
        <template slot="primary">
            <color-picker
                :value="color"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import { generateClass, getClassDefinition } from '@/utils/tailwind-helper';
import colorData from '@/data/constants/colors';

export default {
    name: 'calendar-facet-dot-color',
    mixins: [baseOption],

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            displayName: 'Dot Color',
            message: '',
            color: '',
        };
    },

    methods: {
        onInput(color) {
            let cssClass = '';
            if (color !== colorData.NO_COLOR_FLAG) {
                cssClass = generateClass({
                    screen: this.screen,
                    tailwindDefinitionProp: 'backgroundColor',
                    value: color,
                });
            }
            this.onOptionChange(cssClass);
            this.$emit('input', cssClass);
        },

        onSelectedElement() {
            if (this.value) {
                const classDefinition = getClassDefinition(this.value);
                if (classDefinition) {
                    this.color = classDefinition.value;
                }
            }
        },
    },
};
</script>
